export enum LoginState {
  success,
  rejected,
  changePassword,
  error,
}

export enum SignUpState {
  success,
  rejected,
  error,
}

export enum ResultState {
  success,
  rejected,
  error,
}
